"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bwaInputPincodeWidget = bwaInputPincodeWidget;
var _constants = require("../../../constants/constants");
var _utils = require("../../../utils/utils");
function generateBwAInputPincodeUrl() {
  return (0, _utils.generateUrlWithParams)(_constants.WIDGET_ENDPOINTS.INPUT_PINCODE, {});
}
function bwaInputPincodeWidget(id, cssClass) {
  return (0, _utils.generateIframe)(id, cssClass, generateBwAInputPincodeUrl());
}
//# sourceMappingURL=bwa-input-pincode.js.map
